/// <reference types="@angular/localize" />

import { platformBrowser } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';

import { AppModule } from './app/app.module';

// Register locale data
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeFr, 'fr');

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));
